import React from 'react';
import { Modal } from '../../../postulation_form/components/modal';
import { useTranslation } from 'react-i18next';
import { HrFlexContainer, HrParagraph, HrTitleH3 } from '@components/styles/hr-styles';
import styled from 'styled-components';
import { HrButton } from '@components/button/button';

const Image = styled.figure`
  width: 136px;
  height: 136px;
  margin: 0;

  & img {
    width: 136px;
    height: 136px;
    object-fit: cover;
  }
`;

export const ModalSuccessRequest = ({ modalSucces, width, setModalSuccess, refCurrent, isCreated }) => {
  const closeModal = () => {
    refCurrent.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
    setModalSuccess(false);
  };
  const [t] = useTranslation();
  return (
    <Modal setShowModal={modalSucces} width={width} handleClosedModal={() => {}} noClose>
      <HrFlexContainer flexDirection='column' padding='32px' gap='32px'>
        <Image>
          <img src='/assets/img/ok.png' alt={t('postulant.modal.successful_update.img_alt')} />
        </Image>
        <HrFlexContainer gap='8px' justifyContent='center'>
          <HrTitleH3 color='#24bb72' textAlign='center'>
            Solicitud enviada con éxito
          </HrTitleH3>
          <HrParagraph textAlign='center'>Le comunicaremos vía email el estado de su solicitud.</HrParagraph>
        </HrFlexContainer>
      </HrFlexContainer>
    </Modal>
  );
};
